import type { Expense } from "@torre/expenses";

// Reembolsable / no reembolsable: una sola regla para el diálogo, la etiqueta de
// la lista, el filtro y el KPI «Sin decidir» del flujo de efectivo.

export type Attribution = "company" | "reimbursable" | "not_reimbursable" | "undecided";

/**
 * Cómo se muestra un gasto. Un cargo de estado de cuenta sin decisión queda
 * «sin decidir» aunque venga marcado `personal` de una carga anterior: si no, al
 * guardar cualquier otro campo se grabaría NO REEMBOLSABLE sin que nadie lo decidiera
 * (y el KPI lo seguiría contando como pendiente).
 */
export function attributionOf(e?: Partial<Expense> | null): Attribution {
  if (e?.reimbursable === true) return "reimbursable";
  if (e?.reimbursable === false) return "not_reimbursable";
  if (e?.source === "estado_cuenta") return "undecided";
  return e?.personal ? "not_reimbursable" : "company";
}

/**
 * Etiqueta de la lista, alineada con el filtro de la API: `reimbursable` /
 * `not_reimbursable` solo con decisión guardada, `pending` para un cargo de estado
 * de cuenta sin decidir y `personal` para lo no atribuible capturado a mano.
 */
export function reimbursableChip(e: Partial<Expense>): "reimbursable" | "not_reimbursable" | "pending" | "personal" | null {
  if (e.reimbursable === true) return "reimbursable";
  if (e.reimbursable === false) return "not_reimbursable";
  if (e.source === "estado_cuenta") return "pending";
  return e.personal ? "personal" : null;
}
